<template>
    <el-menu
            class="layout-sidebar"
            :default-active="menuActiveName || 'home'"
            :default-openeds="openeds"
            background-color="#f3f5f7"
            text-color="#6f7788"
            active-text-color="#99003a"
            mode="vertical"
    >
        <!--<router-link to="/">-->
        <!--<el-menu-item index="/home">-->
        <!--<i class="el-icon-c-scale-to-original"></i>-->
        <!--<span>布局示例一</span>-->
        <!--</el-menu-item>-->
        <!--</router-link>-->
        <!--<router-link to="/block">-->
        <!--<el-menu-item index="/block">-->
        <!--<i class="el-icon-date"></i>-->
        <!--<span>布局示例二</span>-->
        <!--</el-menu-item>-->
        <!--</router-link>-->
        <el-menu-item index="home" @click="$router.push({ name: 'home' })">
            <i class="el-icon-s-home"></i>
            <span slot="title">首页</span>
        </el-menu-item>
        <sub-menu
                v-for="menu in menuList"
                :key="menu.id"
                :menu="menu"
                :dynamicMenuRoutes="dynamicMenuRoutes">
        </sub-menu>
    </el-menu>
</template>

<script>
    import SubMenu from './sub-menu'
    import {isURL} from '@/utils/validate'

    export default {
        data() {
            return {
                openeds: ['1'],
                dynamicMenuRoutes: []
            }
        },
        components: {
            SubMenu
        },
        computed: {
            menuList: {
                get() {
                    return this.$store.state.common.menuList
                },
                set(val) {
                    this.$store.commit('common/updateMenuList', val)
                }
            },
            menuActiveName: {
                get() {
                    return this.$store.state.common.menuActiveName
                },
                set(val) {
                    this.$store.commit('common/updateMenuActiveName', val)
                }
            },
            mainTabs: {
                get() {
                    return this.$store.state.common.mainTabs
                },
                set(val) {
                    this.$store.commit('common/updateMainTabs', val)
                }
            },
            mainTabsActiveName: {
                get() {
                    return this.$store.state.common.mainTabsActiveName
                },
                set(val) {
                    this.$store.commit('common/updateMainTabsActiveName', val)
                }
            }
        },
        watch: {
            $route: 'routeHandle'
        },
        created() {
            this.menuList = JSON.parse(sessionStorage.getItem('menuList') || '[]')
            this.dynamicMenuRoutes = JSON.parse(sessionStorage.getItem('dynamicMenuRoutes') || '[]')
            this.routeHandle(this.$route)
        },
        methods: {
            routeHandle(route) {
                if (route.meta.isTab) {
                    // Tab选中, 不存在先添加
                    let tab = this.mainTabs.filter(item => item.name === route.name)[0]
                    if (!tab) {
                        if (route.meta.isDynamic) {
                            route = this.dynamicMenuRoutes.filter(item => item.name === route.name)[0]
                            if (!route) {
                                return console.error('未能找到可用标签页!')
                            }
                        }
                        tab = {
                            menuId: route.meta.id || route.name,
                            name: route.name,
                            title: route.meta.title,
                            type: isURL(route.meta.iframeUrl) ? 'iframe' : 'module',
                            iframeUrl: route.meta.iframeUrl || '',
                            params: route.params,
                            query: route.query
                        }
                        this.mainTabs = this.mainTabs.concat(tab)
                    }
                    this.menuActiveName = tab.menuId + ''
                    this.mainTabsActiveName = tab.name
                }
            }
        }
    }
</script>

<style lang="scss">
    .el-menu-item, .el-submenu__title{
        height: 46px !important;
        line-height: 46px !important;
    }
    .el-submenu .el-menu-item{
        height: 40px !important;
        line-height: 40px !important;
    }
    .layout-sidebar {
        height: 100%;
        text-align: left;
        background: #f3f5f7 !important;
    }
</style>
